import { ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { EnrollmentCondition } from "../../models/EnrollmentCondition";
import { CreateEnrollmentConditionRequest } from "./CreateEnrollmentConditionRequest";
import { EditEnrollmentConditionRequest } from "./EditEnrollmentConditionRequest";
import { SearchEnrollmentConditionRequest } from "./SearchEnrollmentConditionRequest";

const enrollmentConditionUrlPrefix: string = "enrollment-conditions";
export const searchEnrollmentConditions = async (request: SearchEnrollmentConditionRequest) => {
  let result = await api.get(
      `${enrollmentConditionUrlPrefix}/search`,
      request
  ) as PagedResult<EnrollmentCondition>;
  setDatesEnrollmentConditions(result.results);
  return result;
}

export const getEnrollmentConditionById = async (id: number) => {
  let result = await api.get(
      `${enrollmentConditionUrlPrefix}/${id}`
  ) as EnrollmentCondition;
  setDatesEnrollmentCondition(result);
  return result
}

export const createEnrollmentCondition = async (request: CreateEnrollmentConditionRequest) => {
  return api.post(
      `${enrollmentConditionUrlPrefix}`,
      request
  ) as Promise<number>
}

export const editEnrollmentCondition = async (id: number, request: EditEnrollmentConditionRequest) => {
  return api.put(
      `${enrollmentConditionUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const deleteEnrollmentCondition = async (id: number) => {
  return api.delete(
      `${enrollmentConditionUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportEnrollmentConditions = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${enrollmentConditionUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

const setDatesEnrollmentConditions = (items: EnrollmentCondition[]) => {
  for (let item of items) {
    setDatesEnrollmentCondition(item);
  }
}

const setDatesEnrollmentCondition = (item: EnrollmentCondition) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}